import React from "react";
import { Link } from "react-router-dom";
import { IoIosRefresh } from "react-icons/io";
import * as opOrderStatsService from "../services/openprintStats.service";

class OpOpenOrdersCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      totalOrders: null,
      todaysOrders: null,
    };
  }

  componentDidMount() {
    this.loadSummary();
  }

  loadSummary = () => {
    opOrderStatsService
      .getOpenOrdersSummary()
      .then((response) => {
        this.setState({
          totalOrders: response.totalOrders,
          todaysOrders: response.todaysOrders,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  refresh = () => {
    this.loadSummary();
  };

  render() {
    return (
      <div className="shadow-lg ml-0.5 mt-1 px-4 py-6 w-full bg-gray-800 relative grow">
        <span className="text-sm w-max text-white dark:text-white font-semibold border-b border-gray-200">
          Open Orders
        </span>
        <button onClick={this.refresh} className="float-right text-md text-white">
          <IoIosRefresh className="hover:text-green-700" />
        </button>

        <Link to="/openprint/orders" className="block hover:opacity-90">
          <p className="text-xs uppercase text-gray-400 mt-4 mb-1">Total Orders</p>
          <div className="flex items-end space-x-2 mb-4">
            <p className="text-5xl text-white dark:text-white font-bold">
              {this.state.totalOrders}
            </p>
          </div>
        </Link>

        <hr className="mb-5" />

        <Link to="/openprint/orders/today" className="block hover:opacity-90">
          <p className="text-xs uppercase text-gray-400 mb-1">Today's Orders</p>
          <div className="flex items-end space-x-2 my-2">
            <p className="text-5xl text-white dark:text-white font-bold">
              {this.state.todaysOrders}
            </p>
          </div>
        </Link>

        <Link
          to="/openprint/orders"
          className="text-xs text-blue-300 hover:text-blue-200 underline mt-2 inline-block"
        >
          View All Orders
        </Link>
      </div>
    );
  }
}

export default OpOpenOrdersCard;
